import script from "./UOrgPayInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./UOrgPayInfo.vue?vue&type=script&setup=true&lang=ts"

import "./UOrgPayInfo.vue?vue&type=style&index=0&id=01791020&lang=css"

const __exports__ = script;

export default __exports__